<template>
  <!-- 典型案例列表页  -->
  <div class="caseList">
    <!-- 顶部banner背景图 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <div class="center-wrap">
      <!-- 排序及查询 -->
      <div class="search-wrap f-r j-b a-c">
        <!-- 面包屑 -->
        <!-- <div class="nav f-r a-c">
          <span style="color: #808080">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>典型案例列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>-->
        <div class="sort">
          排序：
          <span :class="curIndex == 0 ? 'cur': ''" @click="curIndex = '0'">
            最热
            <i class="el-icon-bottom"></i>
          </span>
          <span :class="curIndex == 1 ? 'cur': ''" @click="curIndex = '1'">
            最新
            <i class="el-icon-top"></i>
          </span>
        </div>
        <div class="search">
          <div class="greatField-con-search">
            <el-input
              placeholder="请输入案例名称"
              v-model="caseName"
              @keyup.native.enter="query()"
              ref="search"
            >
              <template slot="append">
                <div class="greatField-con-search-icon" @click="query()"></div>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table f-r j-s">
        <div class="empty" v-if="dataList.length == 0">暂无数据</div>
        <div
          class="tableItem"
          v-for="(item,index) in  dataList"
          :key="index"
          @click="goCaseDetail(item.uuid)"
        >
          <div :style="{backgroundImage: `url(${item.pic})`}" class="case-pic"></div>
          <div class="case-content">
            <div class="case-title over-num-lines">{{item.title}}</div>
            <div class="case-con over-num-lines num2-lines">{{item.description}}</div>
          </div>
        </div>
      </div>
      <!-- 案例分页 -->
      <div class="casePage" v-if="dataList.length > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[12, 24]"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaseList, getDictionaryItem } from "@/utils/interface";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      headerBgUrl: require("../../assets/publicService/digitalize/27.png"),
      curIndex: "0",
      caseName: "", // 案例名称
      dataList: [
        // {
        //   pic: require("../../assets/publicService/newsConsult/11.png"),
        //   title: "大型集团业财数字融合解决方案",
        //   description: "大型集团业财数字融合解决方案"
        // }
      ],
      total: 0,
      pageSize: 12,
      current: 1,
      timer: null
    };
  },
  watch: {
    curIndex() {
      this.query();
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getBanner();
    // this.query();
    if (this.$route.query.title) {
      this.caseName = this.$route.query.title;
      this.$refs.search.focus();
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: 420,
            behavior: "smooth"
          });
        }
      });
    }
    this.query();
  },
  methods: {
    getBanner() {
      getDictionaryItem({
        groupCode: "dxALBN"
      }).then(res => {
        this.headerBgUrl = res[0].value;
      });
    },
    query() {
      let params = {
        status: 1,
        current: this.current,
        pageSize: this.pageSize,
        title: this.caseName
      };
      if (this.curIndex == "0") {
        params.hot = 1;
      }
      getCaseList(params).then(res => {
        if (res.list && res.list.length > 0) {
          this.dataList = res.list;
          this.total = res.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    // 去案例详情页
    goCaseDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 特色服务分页查询
    handleSizeChange(val) {
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 420);
      this.query();
    }
  }
};
</script>
<style lang="less" scoped>
@basic-colors: #2d50a1;
.caseList {
  position: relative;
  margin-top: -80px;
  background-color: #ffffff;
  /* 暂无数据 */
  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num2-lines {
    -webkit-line-clamp: 2;
  }
  /* 顶部banner */
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  /* 搜索部分 */
  .center-wrap {
    width: 1300px;
    margin: 0 auto;
    font-weight: bold;
    .search-wrap {
      height: 70px;
      width: 100%;
      position: relative;
      .nav {
        position: absolute;
        font-size: 14px;
        top: 4px;
      }
      .sort {
        .cur {
          color: #2d50a1;
        }
        span {
          cursor: pointer;
          margin-right: 5px;
        }
      }
      .search {
        .greatField-con-search {
          width: 300px;
          // box-shadow: 0 0 10px #9999998a;
          border: 1px solid #efefef;
          border-radius: 24px;

          .greatField-con-search-icon {
            width: 30px;
            height: 30px;
            background: url("../../assets/publicService/search.png") no-repeat
              center center/25px 26px;
          }
        }
      }
    }
    .table {
      flex-wrap: wrap;
      position: relative;
      min-height: 400px;
      .tableItem {
        width: 300px;
        height: 260px;
        margin-bottom: 20px;
        margin-right: 30.5px;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        border: 1px solid #efefef;
        cursor: pointer;

        &:nth-of-type(4n) {
          margin-right: 0px;
        }
        .case-pic {
          width: 100%;
          height: 184px;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          background: center center/100% 100% no-repeat;
        }
        .case-content {
          flex: 1;
          .case-title {
            height: 30px;
            line-height: 30px;
            text-align: left;
            padding: 0 10px;
          }
          .case-con {
            height: 40px;
            text-align: left;
            padding: 0 10px;
            font-size: 14px;
            color: #44556694;
          }
        }
      }
    }
    .casePage {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;

      /deep/.el-pagination button:disabled {
        background-color: transparent;
        border: 1px solid #efefef;
        border-radius: 5px;
      }
      /deep/ .el-pagination .btn-prev {
        border: 1px solid #efefef;
        border-radius: 5px;
      }
      /deep/ .el-pagination .btn-next {
        border: 1px solid #efefef;
        border-radius: 5px;
      }
      /deep/.el-pagination .btn-prev {
        padding-right: 0;
      }

      /deep/.el-pager li {
        border: 1px solid #efefef;
        border-radius: 5px;
        margin: 0 5px;
      }

      /deep/.el-pager li.active {
        color: #fff;
        background-color: @basic-colors;
      }
    }
  }
  /* 搜索框样式 */
  /deep/ .el-input-group--append .el-input__inner {
    height: 40px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border: none;
  }

  /* 搜索图标样式 */
  /deep/ .el-input-group__append {
    padding: 0 12px;
    background-color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border: none;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newHome/caseList.vue